import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBusMui = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 24,
	viewBox: "0 0 22 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_7_124)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5 17.625C5.60938 17.625 6.125 17.1562 6.125 16.5C6.125 15.8906 5.60938 15.375 5 15.375C4.34375 15.375 3.875 15.8906 3.875 16.5C3.875 17.1562 4.34375 17.625 5 17.625ZM17 17.625C17.6094 17.625 18.125 17.1562 18.125 16.5C18.125 15.8906 17.6094 15.375 17 15.375C16.3438 15.375 15.875 15.8906 15.875 16.5C15.875 17.1562 16.3438 17.625 17 17.625ZM11 0C5.14062 0 0.5 2.4375 0.5 4.5V18C0.5 19.125 1.0625 20.0625 2 20.625V23.25C2 23.6719 2.32812 24 2.75 24C3.125 24 3.5 23.6719 3.5 23.25V21H18.5V23.25C18.5 23.6719 18.8281 24 19.25 24C19.625 24 20 23.6719 20 23.25V20.625C20.8906 20.0625 21.5 19.125 21.5 18V4.5C21.5 2.4375 16.8125 0 11 0ZM20 18C20 18.8438 19.2969 19.5 18.5 19.5H3.5C2.65625 19.5 2 18.8438 2 18L1.95312 13.5H2H20V18ZM20 12H1.95312V6H20V12ZM2 4.5C2.09375 3.75 5.375 1.5 11 1.5C16.5781 1.5 19.9062 3.79688 20 4.5H2Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7_124",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 22,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgBusMui);
export { ForwardRef as ReactComponent };
